export enum Endpoints {
    Accounts = "/accounts",
    AccountCreditEntries = "/account-credit-entries",
    AccountFees = "/account-fees",
    AccountPhoneNumbers = "/account-phone-numbers",
    AccountTypes = "/account-types",
    AccountUnits = "/account-units",
    AppSettings = "/appsettings",
    AuditLogs = "/audit-logs",
    AuditLogCategories = "/audit-log-categories",
    Aws = "/aws",
    CallBacks = "/call-backs",
    Cases = "/cases",
    CaseFiles = "/case-files",
    CaseFollowUps = "/case-follow-ups",
    CaseNote = "/case-notes",
    Claims = "/claims",
    Countries = "/countries",
    Determinations = "/determinations",
    Donors = "/donors",
    FeeTypes = "/fee-types",
    FollowUps = "/follow-ups",
    ForgotPassword = "/users/forgot_password",
    Forms = "/forms",
    FormCategories = "/form-categories",
    FormSelectCategories = "/form-select-categories",
    FormData = "/form-data",
    FormDataArchives = "form-data-archives",
    FormSelects = "/form-selects",
    FormSelectOptions = "/form-select-options",
    FormTypes = "/form-types",
    Impersonation = "/users/impersonate",
    Invoices = "/invoices",
    Labels = "/labels",
    LabelTypes = "/label-types",
    LabKey = "/labkey",
    Lists = "/lists",
    LogImpersonation = "/users/log_impersonation",
    Login = "/auth/login",
    LoginExternal = "/auth/login/external",
    NotificationConfigs = "/notification-configs",
    Offices = "/offices",
    Orders = "/orders",
    Person = "/person",
    PersonTypes = "/person-types",
    Photos = "/photos",
    Procedures = "/procedures",
    ProcedureTypes = "/procedure-types",
    Quickbooks = "/qbo",
    Recoveries = "/recoveries",
    Referrals = "/referrals",
    ReferralImports = "/referrals-external",
    Refresh = "/auth/refresh-token",
    ResetPassword = "/users/reset_password",
    Roles = "/roles",
    RoleClaims = "/claims/role",
    Shipments = "/shipments",
    ShippingMethods = "/shipping-methods",
    ShippingStatuses = "/shipping-statuses",
    StandardFees = "/standard-fees",
    Surgeries = "/surgeries",
    SurgerySchedulerSurgeon = "/surgery-scheduler-surgeons",
    SurgeryStatuses = "/surgery-statuses",
    SurgeryTypes = "/surgery-types",
    TenantAppSettings = "/appsettings/tenants",
    Tenants = "/tenants",
    Territories = "/territories",
    TissueOffers = "/tissue-offers",
    TissueOfferStatus = "/tissue-offer-statuses",
    TissueReports = "/tissue-reports",
    Tissues = "/tissues",
    TissueStorage = "/tissue-storage",
    TissueTypes = "/tissue-types",
    Users = "/users",
    UserClaims = "/claims/user",
    UserProfile = "user-profiles",
    UserRoles = "/user-role-tenants",
    UserSummary = "/users/me",
    UpdateEmail = "/users/email",
    UpdateProfilePassword = "/users/reset_profile_password",
}
